import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e669061"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container px-0 pb-705 pt-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_ForecastOverviewTableComponent = _resolveComponent("ForecastOverviewTableComponent")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AcceptModal = _resolveComponent("AcceptModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, null, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "forecast.calculate-forecast.title" })
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_RichText, { "text-key": "forecast.calculate-forecast.header-text" })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", null, [
        _createVNode(_component_SimpleText, { textKey: 'forecast.overview.title' }, null, 8, ["textKey"])
      ]),
      _createVNode(_component_ForecastOverviewTableComponent, {
        id: "drafts",
        ref: "forecastTable",
        forecasts: _ctx.combinedInfo,
        "pending-forecast-ids": _ctx.pendingForecasts.map(x => {return x.forecastId}),
        onEditForecast: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editForecast($event))),
        onDeleteForecast: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDeleteForecast($event))),
        onReductionForecast: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editReductionTarget($event)))
      }, null, 8, ["forecasts", "pending-forecast-ids"]),
      _hoisted_2,
      _createVNode(_component_router_link, {
        to: "/forecast/calculate-forecast",
        class: "button button-primary mr-4",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createNew()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SimpleText, { textKey: 'forecast.overview.button.new' }, null, 8, ["textKey"])
        ]),
        _: 1
      })
    ]),
    (_ctx.forecastToDelete.forecastId && _ctx.forecastToDelete.forecastId > 0)
      ? (_openBlock(), _createBlock(_component_AcceptModal, {
          key: 0,
          "value-object": _ctx.forecastToDelete,
          "title-key": 'forecast.dialog.delete.title',
          "buttons-disabled": _ctx.disableDeleteModalButtons,
          "button-ok-text-key": 'forecast.dialog.delete.button.ok',
          "button-reject-text-key": 'forecast.dialog.delete.button.cancel',
          onSelectOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteForecast($event))),
          onSelectReject: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetForecastToDelete()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, [
                _createVNode(_component_SimpleText, { textKey: 'forecast.dialog.delete.text1' }, null, 8, ["textKey"])
              ]),
              _hoisted_3,
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.forecastToDelete.name) + " ", 1),
              _hoisted_5,
              _hoisted_6,
              _createVNode(_component_SimpleText, { textKey: 'forecast.dialog.delete.text2' }, null, 8, ["textKey"])
            ])
          ]),
          _: 1
        }, 8, ["value-object", "title-key", "buttons-disabled", "button-ok-text-key", "button-reject-text-key"]))
      : _createCommentVNode("", true)
  ], 64))
}